import { Button, makeStyles, MenuItem, Paper, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    filterGroup: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: 20,
        paddingTop: 20,
        width: '50%',
        justifyContent: 'space-between'
    }
}))

function ConfigFilter(props) {
    const classes = useStyles();
    const {t} = useTranslation('slotAssignment');

    const DEFAULT_FILTERED = {
        machine_code: '-1',
        target_warehouse: '-1'
    }

    const [filtered, setFiltered] = useState(DEFAULT_FILTERED);

    function handleFiltered(type, item) {
        setFiltered(prev => ({
            ...prev,
            [type]: item
        }));
    }

    useEffect(() => {
        setFiltered(DEFAULT_FILTERED);
    }, [])

    return (
        <Paper className={classes.filterGroup}>
            {
                props.filterRows?.length > 0 &&
                props.filterRows.map((row) => (
                    <TextField
                        select
                        variant="outlined"
                        value={filtered[row.id]}
                        onChange={(e)=>handleFiltered(row.id, e.target.value)}
                        label={t(row.id)}
                        fullWidth
                        style={{marginRight: 10}}
                    >
                        <MenuItem value={`-1`}>{t('common:all')}</MenuItem>
                    {
                        row.list.map((item) => (
                            <MenuItem value={item.id} key={item.id}>{item.short_name}</MenuItem>
                        ))
                    }
                    </TextField>
                ))
            }
            <Button
                variant="contained"
                color='secondary'
                onClick={()=>props.handleFilter(filtered)}
            >
                {t('common:filter')}
            </Button>
        </Paper>
    );
}

export default ConfigFilter;